import { useRouter } from "next/router";
import { isOnlineShoppingEnabled } from "./email-form/utils";

export const useFilteredFields = questionsResponse => {
  const router = useRouter();
  // online value is dependent on onlineOrShop.json
  const isOnlineShopping = isOnlineShoppingEnabled(router?.query?.t);

  const emailFormKey = isOnlineShopping
    ? `${questionsResponse?.formData?.subject}--${isOnlineShopping}`
    : questionsResponse?.formData?.subject;

  const filteredFields = !isOnlineShopping
    ? questionsResponse?.formData?.fields?.filter(f => f !== "PREFERRED_RESOLUTION")
    : questionsResponse?.formData?.fields;

  return {
    fields: filteredFields,
    emailFormKey,
  };
};
